"use strict";

import http from "@/http";

const BASE_NAME = "/email-accounts";

const list = async () => (await http.get(BASE_NAME)).data;
const create = async account => (await http.post(BASE_NAME, account)).data;
const edit = async (id, account) => (await http.put(`${BASE_NAME}/${id}`, account)).data;
const remove = async id => { await http.delete(`${BASE_NAME}/${id}`); };

export default { list, create, edit, remove };
